import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import {
  CLEAR_EXCESS_BAGGAGES,
  FLAG_GETTING_EXCESS_BAGGAGES,
  GET_EXCESS_BAGGAGES,
} from '../types';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { EXCESS_BAGGAGE_ENDPOINT } from '../../config/endpoints';

const flagGettingExcessBaggages = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_EXCESS_BAGGAGES,
    payload: flag,
  });

const getAllExcessBaggages = (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingExcessBaggages(true));
    const query = tableFilters;
    const url = `${EXCESS_BAGGAGE_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const data = await response.json();
    dispatch({
      type: GET_EXCESS_BAGGAGES,
      payload: data,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingExcessBaggages(false));
  }
};

const clearAllBaggageExcesses = () => (dispatch) =>
  dispatch({
    type: CLEAR_EXCESS_BAGGAGES,
  });

export { getAllExcessBaggages, clearAllBaggageExcesses };
